/** Translate the world's starting setup between the form and persisted configuration. */

export type WorldStartingSetup = 'starter' | 'empty' | `save:${string}`;

/** A selected local save takes precedence; only an explicit false opts out of starter airlines. */
export function startingSetupForConfig(config?: Record<string, unknown> | null): WorldStartingSetup {
  if (typeof config?.local_save_id === 'string' && config.local_save_id !== '') {
    return `save:${config.local_save_id}`;
  }
  return config?.use_preloaded_data === false ? 'empty' : 'starter';
}

/** Change the starting setup without dropping other world settings or retaining an old save selection. */
export function configForStartingSetup(
  setup: WorldStartingSetup,
  existingConfig?: Record<string, unknown> | null,
): Record<string, unknown> {
  const config: Record<string, unknown> = { ...existingConfig, use_preloaded_data: setup !== 'empty' };
  delete config.local_save_id;
  if (setup.startsWith('save:')) config.local_save_id = setup.slice('save:'.length);
  return config;
}
